import { Component } from "react"
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer"
import Pagination from "../../../utils/pagination";
import Modal from "react-modal";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import Loader from "../../../utils/Loader";
import {
    getVisitorCircularCompany_action, insertVisitorCircular_action, getVisitorCircularList_action, delVisitorCircular_action,
    assignCircular_action
} from "../../../actions/admin_module_action/visitorCircular_action/visitorCircular_action";
import { toastError, toastSuccess } from "../../../utils/constants";
import Resizer from "react-image-file-resizer";

import ConfirmationModal from "../../../common_components/confirmationa_modal";

class VisitorCircularAdd extends Component {
    // Initialized Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            companyList: [],
            currentPage: 1,
            circularList: [],
            circularDate: "",
            circularTitle: "",
            circularFile: "",
            circularFileType: "",
            checkedAll: false,
            selectedCompany: [],
            isDelOpen: false,
            circularID: "",
            companyName: "",
            loginAccesslist: [],

            // Err Messages
            circularDateErr: "",
            circularTitleErr: "",
            circularFileErr: "",

            isSendMail: false,
            popArg: [],
            isOpenConfirmationModal: false,
            circularFileName: '',
            confirmationObj: { message: '', buttonName: '', action: '' },
        }
        this.getCircularCompany = this.getCircularCompany.bind(this)
        this.updateItem = this.updateItem.bind(this)
        this.getCircularList = this.getCircularList.bind(this)
        this.insertCircular = this.insertCircular.bind(this)
        this.inputValidate = this.inputValidate.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.resizeFile = this.resizeFile.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
        this.selectAllCompany = this.selectAllCompany.bind(this)
        this.handleCheckedCompany = this.handleCheckedCompany.bind(this)
        this.delCircular = this.delCircular.bind(this)
        this.toggleDelModal = this.toggleDelModal.bind(this)
        this.onSearchClick = this.onSearchClick.bind(this)
        this.getWriteAccess = this.getWriteAccess.bind(this)
        this.getDeleteAccess = this.getDeleteAccess.bind(this)
        this.checkedCirculars = this.checkedCirculars.bind(this)
        this.assignCircular = this.assignCircular.bind(this)
        this.handleConfirmation = this.handleConfirmation.bind(this)
    }

    // Om Component Load
    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        this.getCircularCompany()
        this.getCircularList()
    }

    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.insertCircular()
            }
            if (confirmationObj.action == 1) {
                this.assignCircular()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    // Get Circular Company 
    getCircularCompany() {
        const { companyName } = this.state
        this.setState({ isLoading: true })
        this.props.getVisitorCircularCompany_action(companyName)
            .then((data) => {
                if (data.error != 1) {
                    data.data.length > 0 && data.data.map((item) => {
                        item.Is_Select = false
                    })
                    console.log("getCircularCompany Data", data.data)
                    this.setState({
                        companyList: data.data,
                        isLoading: false
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    // Update Current Page
    updateItem(item) {
        const { companyList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = companyList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(companyList.length / recordsPerPage)
    }

    // Get Circular List
    getCircularList() {
        this.setState({ isLoading: true })
        this.props.getVisitorCircularList_action()
            .then((data) => {
                if (data.error != 1) {
                    console.log("getCircularList Data", data.data)
                    data.data.length > 0 && data.data.map((item) => {
                        item.isSelect = false
                    })
                    this.setState({
                        circularList: data.data,
                        isLoading: false
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }

    // Insert Circular 
    insertCircular(e) {
        const { circularDate, circularFile, circularTitle, circularDateErr, circularFileErr, circularTitleErr, companyList, isSendMail, circularFileType } = this.state
        this.inputValidate()
        if (circularDate != "" && circularTitle != "" && circularFile != "") {
            if (circularDateErr == "" && circularTitleErr == "" && circularFileErr == "") {
                var selectedCompany = []
                selectedCompany = companyList.length > 0 && companyList.filter((item) => item.Is_Select == true)
                if (selectedCompany.length > 0) {
                    // circular data Preparing to store
                    var list = []
                    selectedCompany.map(data => {
                        var mapData = {
                            'AccountID': parseInt(data.AccountID),
                            'ExhVisitorID': parseInt(data.ExhVisitorID),
                        }
                        list.push(mapData)
                    });

                    this.setState({ isLoading: true })
                    this.props.insertVisitorCircular_action(circularDate, circularTitle, circularFile, list, circularFileType, isSendMail)
                        .then((data) => {
                            if (data.error != 1) {
                                this.setState({ isLoading: false })
                                this.handleClear()
                                toastSuccess("Circular Added Successfully")
                                // this.props.navigate('/addcircular')
                                // window.location.reload()
                                this.getCircularCompany()
                                this.getCircularList()
                                this.handleClear()
                            } else {
                                this.setState({ isLoading: false })
                                toastError(data.msg)
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                } else {
                    toastError("Please Select Atleast One Company")
                }
            } else {
                toastError("Please Fill Mandatory Input Fields")
            }
        } else {
            toastError("Please Fill Mandatory Input Fields")
        }



    }

    // Input Feilds Validation
    inputValidate() {
        const { circularDate, circularTitle, circularFile } = this.state

        if (circularDate == "") {
            this.setState({ circularDateErr: 'Please Select Circular Date' })
        }
        if (circularTitle == "") {
            this.setState({ circularTitleErr: 'Please Enter Circular Title' })
        }
        if (circularFile == "") {
            this.setState({ circularFileErr: 'Please Select Circular File' })
        }
    }

    // On Cicular File Select
    onFilePick = async (e, file) => {
        e.preventDefault()
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
                this.setState({
                    circularFile: '',
                    circularFileType: '',
                    // passportFileType: '',
                    // passportFilePath: '',
                })
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf')

                ) {
                    image = await this.onPdfSelect(file[0]);
                    this.setState({ circularFile: image, circularFileName: file[0]['name'], circularFileErr: '' })
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ circularFileType: fileTypeList.length > 0 ? fileTypeList[1] : "" })
                } else {
                    toastError('Only .pdf files are allowed')
                    this.setState({
                        circularFile: '',
                        circularFileName: '',
                        circularFileType: '',
                        // passportFileType: '',
                        // passportFilePath: '',
                    })
                }
            }
        }else {
            this.setState({
                circularFile: '',
                circularFileType: '',
                // passportFileType: '',
                // passportFilePath: '',
            })
        }
    }

    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                500,
                600,
                'JPEG',
                80,
                0,
                (uri) => {
                    resolve(uri);
                },
                "base64",
                300,
                300,
            );
        });

    //on Select All Click
    selectAllCompany(e) {
        const { checkedAll, companyList } = this.state
        this.setState({ checkedAll: !checkedAll })
        const checked = e.target.checked
        companyList.length > 0 && companyList.map((data) => {
            if (checked) {
                data.Is_Select = true
            } else {
                data.Is_Select = false
            }
        })
        this.setState({ selectedCompany: companyList })
    }

    // On Checked Company
    handleCheckedCompany(e, id) {
        const { companyList, selectedCompany } = this.state
        const checked = e.target.checked

        companyList.length > 0 && companyList.map((data) => {
            if (data.ExhVisitorID == id) {
                if (checked) {
                    data.Is_Select = true
                } else {
                    data.Is_Select = false
                    this.setState({ checkedAll: false })
                }
            }
        })
        console.log("aaaaaaaaaaa", companyList)
        this.setState({})
    }

    // On Delete Circular
    delCircular(e) {
        const { circularID } = this.state
        this.setState({ isLoading: true })
        this.props.delVisitorCircular_action(circularID)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        isDelOpen: false,
                        isLoading: false
                    })
                    toastSuccess("Circular Deleted Successfully")
                    this.getCircularList()
                    this.handleClear()
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    //toggle for delete
    toggleDelModal(id) {
        const { isDelOpen } = this.state
        this.setState({
            isDelOpen: !isDelOpen, circularID: id
        })
    }

    // On Search Click
    onSearchClick() {
        this.getCircularCompany()
        setTimeout(() => {
            this.setState({
                currentPage: 1
            })
        }, 200);
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '24');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '14');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    checkedCirculars(e, id) {
        const { circularList } = this.state
        const checked = e.target.checked

        circularList.length > 0 && circularList.map((data) => {
            if (data.CircularVisitorID == id) {
                if (checked) {
                    data.isSelect = true
                } else {
                    data.isSelect = false
                }
            }
        })
        console.log("aaaaaaaaaaa", circularList)
        this.setState({})
    }

    assignCircular() {
        const { circularList, companyList } = this.state
        var selectedCompany = []
        selectedCompany = companyList.length > 0 && companyList.filter((item) => item.Is_Select == true)
        var selectedCircular = []
        selectedCircular = circularList.length > 0 && circularList.filter((item) => item.isSelect == true)

        if (selectedCircular.length > 0) {
            if (selectedCompany.length > 0) {
                // circular User data Preparing to store
                var list = []
                selectedCompany.map(data => {
                    var mapData = {
                        'AccountID': parseInt(data.AccountID),
                        'ExhVisitorID': parseInt(data.ExhVisitorID),
                    }
                    list.push(mapData)
                });
                // circular data Preparing to store
                var list2 = []
                selectedCircular.map(data => {
                    var mapData = {
                        'CircularID': parseInt(data.CircularVisitorID),
                        'ExhVisitorID': parseInt(data.ExhVisitorID),
                    }
                    list2.push(mapData)
                });
                this.setState({ isLoading: true })
                this.props.assignCircular_action(list, list2, 1, this.state.isSendMail)
                    .then((data) => {
                        if (data.error != 1) {
                            this.setState({ isLoading: false })
                            this.handleClear()
                            toastSuccess("Circular Assign Successfully")
                            this.handleClear()
                        } else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                toastError("Please Select Atleast One Visitor")
            }
        } else {
            toastError("Please Select Atleast One Circular")
        }
    }

    handleClear() {
        const { companyName, paymentTypeId, isSendMail, exhibitorTypeId } = this.state

        this.setState({
            companyName: '',
            paymentTypeId: "",
            exhibitorTypeId: "",
            currentPage: 1,
            circularDate: '',
            circularTitle: '',
            circularFile: '',
            circularFileName: '',
            circularFileType: '',
            checkedAll: false,
            isSendMail: false
        })
        setTimeout(() => {
            this.getCircularCompany()
            this.getCircularList()
        }, 200);
    }

    render() {
        const { isLoading, companyList, currentPage, circularDate, circularTitle, circularDateErr, circularTitleErr, circularFileErr,
            checkedAll, circularList, isDelOpen, companyName, circularFileName, isOpenConfirmationModal
        } = this.state

        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };

        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = companyList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(companyList.length / recordsPerPage)

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                <HeaderWithLogo />
                <AdminDrawer />
                <div className="main-content app-content with-dr-container">
                    <div className="main-container">
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Visitor Circular</h6>
                            </div>
                        </div>
                    </div>
                    <main id="main">
                        <section class="section p-0" >
                            <div className="main-container p-2">
                                <div className="row">
                                    <div className="admin-top-space p-2 pt-0">
                                        <div className="card rounded-0 pt-1 shadow-none">
                                            {/* <div className="card-header p-2">
                                        <h3 className="card-title">Add Circular</h3>
                                    </div> */}
                                            <div className="card-body p-1">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="col-xl-12 p-0">
                                                            <label htmlFor="validationCustom03"> Circular Name<span style={{ color: 'red' }}>*</span></label>
                                                            <input type="text" className="form-control"
                                                                value={circularTitle}
                                                                onInput={toInputUppercase}
                                                                onChange={(e) => this.setState({ circularTitle: e.target.value, circularTitleErr: "" })}
                                                            />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{circularTitleErr}</span>}
                                                        </div>

                                                        <div className="col-xl-12 p-0 mt-2">
                                                            <label htmlFor="validationCustom03">Circular Date<span style={{ color: 'red' }}>*</span></label>
                                                            <DatePicker
                                                                selected={circularDate}
                                                                dateFormat={"dd/MM/yyyy"} className="form-control"
                                                                onChange={(date) => this.setState({ circularDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), circularDateErr: "" })}
                                                                peekNextMonth
                                                                // minDate={new Date()}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                placeholderText="Circular Date"
                                                                dayClassName={() => "example-datepicker-day-class"}
                                                                popperClassName="example-datepicker-class" />
                                                            {<span className='text-danger text-start text-left d-block mt-1'>{circularDateErr}</span>}
                                                        </div>
                                                        <div className="col-xl-12 p-0 mt-2">
                                                            <label htmlFor="validationCustom03">Upload Circular<span style={{ color: 'red' }}>*</span></label>

                                                            <div className="col-xl-12 p-0">

                                                                <div className="mb-0">
                                                                    {circularFileName != "" ? (
                                                                        <>
                                                                            <div className="chooseStallFile w-100 m-0" style={{ justifyContent: "space-between" }}>
                                                                                <p className="overflow-membership m-0 w-100">{circularFileName}</p>
                                                                                <span
                                                                                    className="membership_file_cross text-danger"
                                                                                    onClick={(e) => {
                                                                                        this.setState({
                                                                                            circularFile: '',
                                                                                            circularFileName: '',
                                                                                            circularFileType: '',
                                                                                        })
                                                                                    }}
                                                                                >
                                                                                    X
                                                                                </span>
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <input type="file" className="form-control"
                                                                                accept=".pdf"
                                                                                onChange={e => this.onFilePick(e, e.target.files)}
                                                                            />
                                                                            <p
                                                                                className="text-aqua mb-0"
                                                                                style={{ textAlign: "center" }}
                                                                            >
                                                                                (Only .pdf file are allowed with maximum size of 5mb)
                                                                            </p>
                                                                            {<span className='text-danger text-start text-left d-block mt-1'>{circularFileErr}</span>}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button type="button" className="btn btn-primary mt-4"
                                                            disabled={!this.getWriteAccess()}
                                                            // onClick={(e) => this.insertCircular()}
                                                            onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}
                                                        >
                                                            Add Circular
                                                        </button>
                                                        <div className="row col-sm-5" style={{ float: "right" }}>
                                                            <button type="button" className="btn btn-primary mt-4"
                                                                disabled={!this.getWriteAccess()}
                                                                // onClick={(e) => this.assignCircular()}
                                                                onClick={(e) => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  Assign?`, buttonName: "Assign", action: 1 }, popArg: [] })}
                                                            >
                                                                Assign Circular
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="add-circular">
                                                            <strong><span className="text-aqua m-0">All Circular</span></strong>
                                                            {

                                                                circularList.length > 0 && circularList.map((data, index) => (
                                                                    <p key={Math.random()} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                        <input type="checkbox"
                                                                            value={data.isSelect}
                                                                            checked={data.isSelect}
                                                                            onChange={(e) => this.checkedCirculars(e, data.CircularVisitorID)}
                                                                        />
                                                                        <span>{data.CircularDescription}</span>
                                                                        {/* <i
                                                                            className="fa fa-info-circle"
                                                                            title="View History"
                                                                            style={{ cursor: 'pointer', color: '#6c757d', fontSize: '18px' }}
                                                                            onClick={() => this.openHistoryModal(data.CircularID, data.CircularDescription)}
                                                                        /> */}
                                                                        <i
                                                                            className={`fa fa-trash${this.getDeleteAccess() ? '' : ' text-muted'}`}
                                                                            title="Delete"
                                                                            style={{ cursor: this.getDeleteAccess() ? 'pointer' : 'not-allowed', color: this.getDeleteAccess() ? '#dc3545' : '#aaa', fontSize: '18px' }}
                                                                            onClick={() => this.getDeleteAccess() && this.toggleDelModal(data.CircularVisitorID)}
                                                                        />
                                                                    </p>
                                                                ))
                                                            }

                                                        </div>
                                                    </div>
                                                    <style
                                                        type="text/css"
                                                        dangerouslySetInnerHTML={{
                                                            __html:
                                                                "\n                                    .add-circular{\n                                        height: 300px;\n                                        overflow: auto;\n                                    }\n                                "
                                                        }}
                                                    />

                                                    <div className="row p-0 m-0">
                                                        <div className="row m-0 align-items-end g-2">

                                                            {/* Company Name */}
                                                            <div className="col-md-3">
                                                                <label>Company Name</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Search Company"
                                                                    value={companyName}
                                                                    onChange={(e) => this.setState({ companyName: e.target.value })}
                                                                />
                                                            </div>

                                                            {/* Search Button */}
                                                            <div className="col-md-3 d-flex align-items-end">
                                                                <button
                                                                    className="btn btn-aqua"
                                                                    onClick={() => this.onSearchClick()}
                                                                >
                                                                    Search
                                                                </button>
                                                                <button class="btn btn-aqua mx-2"
                                                                    onClick={(e) => this.handleClear()}
                                                                >Clear</button>
                                                                <div className="form-check mx-2">
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={this.state.isSendMail}
                                                                        onChange={() =>
                                                                            this.setState({ isSendMail: !this.state.isSendMail })
                                                                        }
                                                                    />
                                                                    <label className="form-check-label ms-1">
                                                                        Send Mail
                                                                    </label>
                                                                </div>
                                                            </div>


                                                        </div>

                                                        <div class="table-responsive sticky-table-wrappermt-2 p-0 mt-2">
                                                            <table class="table sticky-table text-nowrap table-bordered border-bottom mb-0">
                                                                <thead class="table-light">
                                                                    <tr>
                                                                        <th className="text-center" style={{ width: 60 }}>
                                                                            <input type="checkbox"
                                                                                checked={checkedAll}
                                                                                onChange={(e) => this.selectAllCompany(e)}
                                                                            />
                                                                        </th>
                                                                        <th className="text-center">Reference ID</th>
                                                                        <th>Company</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        currentRecords.length > 0 ? currentRecords.map((data) => (
                                                                            <tr key={Math.random()}>
                                                                                <td className="text-center">
                                                                                    <input type="checkbox"
                                                                                        value={data.Is_Select}
                                                                                        checked={data.Is_Select}
                                                                                        onChange={(e) => this.handleCheckedCompany(e, data.ExhVisitorID)}
                                                                                    />
                                                                                </td>
                                                                                <td className="text-center">{data.VisitorRegistrationNo}</td>
                                                                                <td>{data.Institute_Organisation}</td>
                                                                            </tr>
                                                                        )) : <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="mt-2 float-left m-0 p-0">
                                                            {
                                                                companyList.length > 0 ?
                                                                    <Pagination
                                                                        nPages={nPages}
                                                                        currentPage={currentPage}
                                                                        setCurrentPage={this.updateItem}
                                                                    /> : <></>
                                                            }
                                                            <div className="tab-rec " style={{ float: "right" }}>
                                                                <p>{`${currentPage} of ${nPages} pages`}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div >

                <Modal isOpen={isDelOpen} onRequestClose={() => this.setState({ isDelOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Confirm Delete</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isDelOpen: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">Do you really want to delete this record?</p>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop" onClick={(e) => this.delCircular(e)}>Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isDelOpen: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>


            </>

        )
    }
}
export default withRouter(connect(null, {
    getVisitorCircularCompany_action, insertVisitorCircular_action, getVisitorCircularList_action, delVisitorCircular_action, assignCircular_action
})(VisitorCircularAdd))